<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>供应系统</el-breadcrumb-item>
        <el-breadcrumb-item>运营管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: 'promotionManage' }"
          >优惠活动</el-breadcrumb-item
        >
        <el-breadcrumb-item>活动详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="hx-form-container box-shadow" v-loading="detailLoading">
      <div style="width: 50%;">
        <el-form
          ref="listForm"
          :model="listParams"
          :rules="checkListParams"
          label-width="150px"
        >
          <el-form-item label=" ">
            <h1 v-if="status === 1" style="color : grey">未使用</h1>
            <h1 v-else-if="status === 2" style="color : orange">已使用</h1>
            <h1 v-else-if="status === 3" style="color : red">已过期</h1>
          </el-form-item>
          <el-form-item label="活动名称：" prop="name">
            <el-input
              size="small"
              placeholder="请输入活动名称"
              v-model.trim="listParams.name"
            ></el-input>
          </el-form-item>
          <el-form-item label="折扣率：" prop="discount">
            <el-input-number
              size="small"
              v-model="listParams.discount"
              :min="1"
              :max="100"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="活动商品：" prop="promotionList">
            <el-select
              @change="goodsChanged"
              style="width: 100%;"
              size="small"
              v-model.trim="listParams.goodsId"
              filterable
              clearable
              remote
              reserve-keyword
              placeholder="请输入参加活动的商品"
              :remote-method="remoteMethod"
            >
              <el-option
                v-for="item in goodsList"
                :label="item.title"
                :value="item.id"
                :key="item.title"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选中商品：">
            <div
              v-for="(item, index) in categoryNameList"
              :key="index"
              style="margin-top: 5px;"
            >
              <div class="e-tag-div-style">
                <span class="e-tag-title">{{ item.title }}：</span>
                <ul class="e-tag-ul-style">
                  <li
                    v-for="(item1, index1) in goodsCategory[
                      'categoryList_' + index
                    ]"
                    :key="index1"
                    class="e-tag-inline e-tag e-tag-info e-tag-mini"
                  >
                    <span class="el-tag-item-text">{{ item1.title }}</span>
                    <i
                      class="e-tag-item-close el-icon-circle-close"
                      @click="
                        deleteItem(
                          goodsCategory['categoryList_' + index],
                          index1,
                          index
                        )
                      "
                    >
                    </i>
                  </li>
                </ul>
              </div>
            </div>
          </el-form-item>
          <date-components
            style="margin-top: 10px;"
            start-prop="startDate"
            end-prop="endDate"
            :start-date="listParams.startDate"
            :end-date="listParams.endDate"
            @set-start-date="getStartDate"
            @set-end-date="getEndDate"
            date-type="date"
            show-type="both"
            label-name="活动周期："
          >
          </date-components>
          <el-form-item label="优惠方式：">
            <el-radio v-model="listParams.type" :label="1">折扣优惠</el-radio>
            <!-- <el-radio v-model="listParams.type" :label="2">现金减免优惠</el-radio> -->
          </el-form-item>
          <el-form-item>
            <el-button
              size="small"
              type="primary"
              :disabled="isDisabled"
              @click="confirm('listForm')"
              >确定</el-button
            >
            <el-button
              size="small"
              @click="$router.push({ name: 'promotionManage' })"
              >取消</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
export default {
  data() {
    return {
      status: "",
      listParams: {
        name: "",
        discount: 10,
        goodsId: "",
        promotionList: [],
        startDate: "",
        endDate: "",
        type: 1
      },
      checkListParams: {
        name: [
          {
            required: true,
            message: "请输入活动名称",
            trigger: "blur"
          }
        ],
        discount: [
          {
            required: true,
            message: "请输入折扣率",
            trigger: "change"
          }
        ],
        promotionList: [
          {
            type: "array",
            required: false,
            message: "请至少添加一个活动商品",
            trigger: "change"
          }
        ],
        startDate: [
          {
            required: true,
            message: "请选择开始时间",
            trigger: "change"
          }
        ],
        endDate: [
          {
            required: true,
            message: "请选择结束时间",
            trigger: "change"
          }
        ]
      },
      goodsList: [],
      isDisabled: false,
      categoryNameList: [],
      goodsCategory: {},
      detailLoading: false
    };
  },
  mounted() {
    this.loadCategoryList();
  },
  methods: {
    /**
     * 加载详情页数据
     * @param id
     */
    loadDetailPage(id) {
      this.detailLoading = true;
      Vue.ajaxGet(
        this,
        global.apiUrl + "/good/promotion/detail",
        {
          id: id
        },
        "detailLoading"
      ).then(res => {
        this.status = res.status;
        this.listParams.name = res.name;
        this.listParams.discount = res.discount;
        this.listParams.type = res.type;
        this.listParams.startDate = res.startDate;
        this.listParams.endDate = res.endDate;
        res.promotionList.map(val => {
          for (const i in this.goodsCategory) {
            if (i === val.type) {
              this.goodsCategory[i].push(val);
            }
          }
        });
      });
    },
    /**
     * 父组件获取子组件传递的开始日期
     * @param startAttr
     * @param startDate
     */
    getStartDate(startAttr, startDate) {
      if (startDate !== "") {
        // 需判断返回的date值是否为空
        this.listParams[startAttr] = new Date(startDate).getTime();
      } else {
        // 若返回值为空则清空该form对象的值，与重置操作自动清空不一样的是，该清空方法
        // 是由点击时间选择器清除按钮事件触发的
        this.listParams[startAttr] = "";
      }
    },
    /**
     * 父组件获取子组件传递的结束日期
     * @param endAttr
     * @param endDate
     */
    getEndDate(endAttr, endDate) {
      if (endDate !== "") {
        this.listParams[endAttr] = new Date(endDate).getTime();
      } else {
        this.listParams[endAttr] = "";
      }
    },
    /**
     * 初始化加载分类名称
     */
    loadCategoryList() {
      this.$http({
        url:
          global.apiUrl +
          "/good/goodcategory/findAll?supplyId=" +
          this.$route.params.supplyId,
        method: "GET"
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            if (res.body.data) {
              this.categoryNameList = res.body.data;
              const categoryObj = "categoryList_";
              res.body.data.map((item, index) => {
                this.goodsCategory[categoryObj + index] = [];
              });
              this.$route.query.id && this.loadDetailPage(this.$route.query.id);
            }
          } else {
            this.categoryNameList = [];
          }
        })
        .catch(err => {

          console.error(err);
        });
    },
    /**
     * 远程搜索商品
     * @param query
     */
    remoteMethod(query) {
      if (query !== "") {
        Vue.ajaxGet(this, global.apiUrl + "/good/promotion/search", {
          name: query
        }).then(res => {
          this.goodsList = res;
        });
      } else {
        this.listParams.goodsId = "";
      }
    },
    /**
     * 商品联想框change事件
     * @param id
     */
    goodsChanged(id) {
      if (this.goodsList.length > 0) {
        this.goodsList.map(val => {
          if (val.id === id) {
            if (!this.isInArray(this.goodsCategory[val.type], id)) {
              this.goodsCategory[val.type].push(val);
            } else {
              this.$message.warning("请勿重复添加商品");
              this.listParams.goodsId = "";
            }
            if (this.goodsList.length === 1) {
              this.goodsList = [];
              this.listParams.goodsId = "";
            }
          }
        });
      }
    },
    /**
     * 判断菜品分类中是否包含所选商品
     * @param arr
     * @param value
     * @returns {boolean}
     */
    isInArray(arr, value) {
      for (let i = 0; i < arr.length; i++) {
        if (value === arr[i].id) {
          return true;
        }
      }
      return false;
    },
    /**
     * 判断一维数组中是否重复添加商品Id
     * @param arr
     * @param value
     * @returns {boolean}
     *
     */
    checkIsContain(arr, value) {
      for (let i = 0; i < arr.length; i++) {
        if (arr[i] === value) {
          return true;
        }
      }
      return false;
    },
    /**
     * 删除菜品分类对应菜品数组
     * @param arr
     * @param index1
     */
    deleteItem(arr, index1, index) {
      arr.map((item, i) => {
        if (i === index1) {
          arr.splice(index1, 1);
        }
      });
      Vue.set(this.goodsCategory, "categoryCopy", arr);
      delete this.goodsCategory.categoryCopy;
    },
    /**
     * 确认提交
     * @param name
     */
    confirm(name) {
      this.listParams.promotionList = [];
      this.isDisabled = true;
      this.$refs[name].validate(valid => {
        if (valid) {
          const goods = this.goodsCategory;
          for (const i in goods) {
            if (goods[i].length > 0) {
              goods[i].map(item => {
                if (this.listParams.promotionList.length > 0) {
                  if (
                    !this.checkIsContain(this.listParams.promotionList, item.id)
                  ) {
                    this.listParams.promotionList.push(item.id);
                  }
                } else {
                  this.listParams.promotionList.push(item.id);
                }
              });
            }
          }
          const bodyParams = Object.assign({}, this.listParams);
          delete bodyParams.goodsId;
          let method = "";
          if (this.$route.query.id) {
            method += "PUT";
            bodyParams.id = this.$route.query.id;
          } else {
            method += "POST";
          }
          this.$http({
            method: method,
            url: global.apiUrl + "/good/promotion/add",
            body: bodyParams
          })
            .then(res => {
              this.isDisabled = false;
              if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
                this.$message.success(res.body.info);
                this.$router.push({
                  name: "promotionManage"
                });
              } else {

              }
            })
            .catch(err => {
              this.isDisabled = false;
              console.log(err);

            });
        } else {
          this.isDisabled = false;
        }
      });
    }
  },
  watch: {
    "listParams.timeInterval": function(val, oldVal) {
      console.log(val);
    }
  }
};
</script>

<style lang="less" scoped></style>
